module.exports = __webpack_public_path__ + "img/Speaker=Muna Khayyat.1c41f61f.png";